import React, { useCallback } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { IPanel } from '../../interfaces/Panel.interface';

// STYLES
import { 
  Container, 
  Options, 
  Actions, 
  Button, 
  IconContainer
} from './styles';

const Panel: React.FC<IPanel> = ({
  actionIcon,
  actionTitle = 'Aplicar',
  active,
  children,
  disabled = false,
  hasScroll = false,
  id,
  leftSide,
  onApply,
  rightSide,
}: IPanel) => {
  const handleApply = useCallback(() => {
    if (!disabled) {
      onApply();
    }
  }, [onApply, disabled]);

  return (
    <Container active={active} leftSide={leftSide} rightSide={rightSide}>
      <Options hasScroll={hasScroll} id={id}>
        {children}
      </Options>
      <Actions onClick={handleApply}>
        <Button onClick={handleApply} disabled={disabled}>
          {actionTitle}
        </Button>
        <IconContainer onClick={handleApply} disabled={disabled}>
          <Icon type={actionIcon || Icons.MUCH_ARROW_RIGHT} />
        </IconContainer>
      </Actions>
    </Container>
  );
};

export default Panel;
